import React, { Component } from 'react';
import {
  Button,
  Label,
  Input,
  Form,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter
} from 'reactstrap';
import { mockFood } from '../../mockData';


export default class AdminSetMenu extends Component {
  state = {
    set: [],
    meat: [],
    rice: [],
    veg: [],
    side: [],
    special: [],
    modal: false
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  }

  makeOptions = (food) => {
    return (
      <div key={food._id} className="fancy">
        <Input
          className="fancy-label"
          id={food._id}
          value={JSON.stringify(food)}
          type="checkbox" />
        <Label className="fancy-lg" for={food._id} check key={food._id}>{food.name}</Label>
      </div>
    );
  }

  getFood = () => {
    const food = mockFood;

    let meat = food.filter(f => f.type === 'meat').map(this.makeOptions)
    let rice = food.filter(f => f.type === 'rice').map(this.makeOptions)
    let veg = food.filter(f => f.type === 'veg').map(this.makeOptions)
    let side = food.filter(f => f.type === 'side').map(this.makeOptions)
    let special = food.filter(f => f.type === 'special').map(this.makeOptions)

    this.setState({meat, rice, veg, side, special});
  }

  postMenu = () => {
    alert("Demo mode: menu not actually set.");
  }

  setMenu = (e) => {
    e.preventDefault();

    let food = [...e.target.elements]
      .filter(food => food.checked === true)
      .map(food => JSON.parse(food.value))

    this.setState({set: food}, this.postMenu)
  }

  importMenu = (e) => {
    e.preventDefault();
    alert("Demo mode: import is disabled.");
  }

  componentDidMount() {
    this.getFood();
  }

  render() {
    return (
      <div>
        <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
          <ModalHeader toggle={this.toggle}>Dis right?</ModalHeader>
          <ModalBody>
            <ul>
            {this.state.set && this.state.set.map(item => <li key={item._id}>{item.name}</li>)}
            </ul>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => {this.postMenu(); this.toggle();}}>Set</Button>{' '}
            <Button color="secondary" onClick={this.toggle}>Cancel</Button>
          </ModalFooter>
        </Modal>

        <div>
          <h1>Wah kinda food yuh have?</h1>
          <Form onSubmit={this.importMenu}>
            <Label for="import">Menu from email</Label>
            <Input rows="10" type="textarea" name="menu" id="import" />
            <Button size="sm" color="primary">Import</Button>
          </Form>

          <div style={{height: '30px'}}></div>

          <Form onSubmit={this.setMenu}>
          <span>Manual menu entry</span>
            <h2>Specials</h2><hr />
            {this.state.special}

            <h2>Meat</h2><hr />
            {this.state.meat}

            <h2>Rice</h2><hr />
            {this.state.rice}

            <h2>Vegetable</h2><hr />
            {this.state.veg}

            <h2>Side</h2><hr />
            {this.state.side}

            <Button className="launsh-btn" size="lg" color="primary">Set</Button>
          </Form>
        </div>
      </div>
    )
  }
}
